!function() {
  "use strict";
  customElements.get("site-header") || customElements.define("site-header", class extends HTMLElement {
    mobileToggle=this.querySelector("#MobileSearch");
    labels=this.querySelectorAll("[data-links] > label");
    closers=this.querySelectorAll("[data-close]");
    closeMenus() {
      this.querySelectorAll('input:is([type="radio"],[type="checkbox"])').forEach((e => e.checked = !1)), 
      window.dispatchEvent(new Event("click"));
    }
    addEventListeners() {
      this.mobileToggle.addEventListener("change", (() => Shopify.debounce(this.mobileToggle.checked && document.querySelector('#MobileSearchForm [name="q"]')?.focus()))), 
      this.labels.forEach((e => {
        e.addEventListener("mouseenter", (() => {
          const t = document.getElementById(e.getAttribute("for"));
          t && !t.checked && (t.checked = !0), document.getElementById("Search").checked = !1;
        }), {
          passive: !0
        }), e.dataset.url && e.addEventListener("click", (t => {
          t.preventDefault(), window.location.href = e.dataset.url;
        }));
      })), this.closers.forEach((e => {
        switch (e.dataset.close) {
         case "hover":
          e.addEventListener("mouseenter", (() => this.closeMenus()), {
            passive: !0
          });
          break;

         case "click":
          e.addEventListener("click", (() => this.closeMenus()));
        }
      }));
    }
    constructor() {
      super();
    }
    connectedCallback() {
      this.addEventListeners();
    }
  });
}();